import React, { useContext } from 'react';
import { MuiAppContext, MuiPaginationServerSideProps } from '@lsoft/mui';
import { ShopPage } from '../src/app/ShopPage';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { shopServerSideProps } from '../src/tools/withShopPropsContext';
import { ShopSearchView } from '../src/components/ShopSearch/ShopSearchView';
import { getTranslation, Tr } from '@lsoft/translate';
import { compose } from 'redux';
import {
	trSearch,
	trYourSearchFor,
} from '../src/components/ShopSearch/ShopSearch.tr';
import { GTMProductList } from '../src/container/shop/GTMProductList';

const Search = ({ q, paginationViewParams, ...pageProps }) => {
	const { scrollTop } = useContext(MuiAppContext);
	return (
		<ShopPage {...pageProps} noLogin variant={'sidebarMenu'}>
			<GTMProductList list={'search_result'}>
				<Typography variant={'h5'} component={'h1'}>
					<Tr tr={trYourSearchFor} format={{ q: q }} />
				</Typography>
				<ShopSearchView
					q={q}
					onPageChange={() => {
						scrollTop();
					}}
					paginationViewParams={paginationViewParams}
				/>
			</GTMProductList>
		</ShopPage>
	);
};
Search.propTypes = {
	q: PropTypes.string,
	paginationViewParams: PropTypes.object,
};

export const getServerSideProps = compose(
	shopServerSideProps,
	MuiPaginationServerSideProps
)(async ({ query, locale, paginationViewParams }) => {
	const title = `${getTranslation(trSearch, locale)}: ${query.q}`;
	return {
		props: {
			pageInfo: {
				title: title,
			},
			q: query.q,
			paginationViewParams: paginationViewParams,
		},
	};
});

export default Search;
